import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Alert, Card, CardBody, Badge, Button } from 'reactstrap';
import Page from '../../../../components/Page';
import Steps from '../../../../components/Generales/Steps';
import LoadingScreen from 'react-loading-screen';
import logo from 'assets/img/logo/logo_aig_login-2.png';

// Acciones Redux
import { obtenerCotizacionMoto, limpiarDatosCotizacion } from '../../redux/aMotos';

// Componentes
import CoberturasMoto from '../../components/CoberturasMoto';
import ValoresCotizacionMoto from '../../components/ValoresCotizacionMoto';

const styles = {
    card: {
        borderRadius: '4px',
        border: '1px solid #e0e0e0',
        marginBottom: '1.5rem',
        backgroundColor: '#ffffff'
    },
    header: {
        padding: '1rem 1.25rem',
        borderBottom: '1px solid #eeeeee',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    titulo: {
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#000000',
        fontFamily: 'Futura, "Trebuchet MS", Arial, sans-serif',
        margin: 0
    },
    boxGris: {
        backgroundColor: '#f2f2f2',
        borderRadius: '4px',
        padding: '16px 20px',
        border: '1px solid #e8e8e8'
    },
    label: {
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#000000',
        fontFamily: 'Futura, "Trebuchet MS", Arial, sans-serif',
        display: 'block',
        marginBottom: '2px'
    },
    valor: {
        fontSize: '14px',
        color: '#515253',
        fontFamily: 'Futura, "Trebuchet MS", Arial, sans-serif',
        margin: 0
    }
};

/**
 * Paso 3: Resumen Visual de Cotización de Motos (Confirmación y Coberturas).
 */
const ResumenMoto = ({
    history,
    location,
    obtenerCotizacionMoto,
    limpiarDatosCotizacion,
    estadoMotos
}) => {
    const [cargando, setCargando] = useState(true);

    const listaOpciones = [
        { id: 0, label: 'Cotización', value: 'cotizacion' },
        { id: 1, label: 'Resumen', value: 'resumen' },
        { id: 2, label: 'Confirmación', value: 'confirmacion' },
        { id: 3, label: 'Forma de Pago', value: 'forma-pago' },
        { id: 4, label: 'Formulario de Vinculación', value: 'formulario-vinculacion' },
        { id: 5, label: 'Emisión', value: 'emision' }
    ];

    var searchStr = (location && location.search) || (window.location && window.location.search) || '';
    var queryParams = new URLSearchParams(searchStr);
    var idCarrito = queryParams.get('idCarrito') || queryParams.get('id');

    useEffect(() => {
        var cargarInformacion = async () => {
            if (idCarrito) {
                setCargando(true);
                limpiarDatosCotizacion();
                await obtenerCotizacionMoto(idCarrito);
                setCargando(false);
            } else {
                setCargando(false);
            }
        };
        cargarInformacion();
    }, [idCarrito]);

    const isGlobalLoading = cargando || (estadoMotos && estadoMotos.isLoading);

    var datosVehiculo = (estadoMotos && estadoMotos.datosVehiculo) || (estadoMotos && estadoMotos.cotizacion && estadoMotos.cotizacion.datosVehiculo) || {};
    var prodMoto = estadoMotos && estadoMotos.carrito && estadoMotos.carrito.carProductos && estadoMotos.carrito.carProductos[0];
    var plan = (estadoMotos && estadoMotos.plan) || (prodMoto && prodMoto.plan);
    var planNombre = (plan && (plan.nombre || plan.tipoPlan)) || (prodMoto && prodMoto.nombrePlan) || 'AIG Moto';

    var esBloqueanteEmision = Boolean(
        (estadoMotos && estadoMotos.esBloqueanteEmision) ||
        (estadoMotos && estadoMotos.carrito && estadoMotos.carrito.esBloqueanteEmision) ||
        (plan && plan.esBloqueanteEmision) ||
        (prodMoto && prodMoto.esBloqueanteEmision)
    );

    var txtBloqueoEmision = (
        (estadoMotos && estadoMotos.txtBloqueoEmision) ||
        (estadoMotos && estadoMotos.carrito && estadoMotos.carrito.txtBloqueoEmision) ||
        (plan && plan.txtBloqueoEmision) ||
        (prodMoto && prodMoto.txtBloqueoEmision) ||
        ''
    );

    var valorTot = (estadoMotos && (estadoMotos.valorTotal || (estadoMotos.carrito && estadoMotos.carrito.valorTotal))) || null;
    var cobsPdf = (estadoMotos && estadoMotos.coberturasPdf) || (estadoMotos && estadoMotos.carrito && estadoMotos.carrito.coberturasPdf) || null;
    var coberturas = (cobsPdf && cobsPdf.length > 0)
        ? cobsPdf
        : ((estadoMotos && estadoMotos.coberturas) || (estadoMotos && estadoMotos.cotizacion && estadoMotos.cotizacion.coberturas) || []);

    var da = (estadoMotos && estadoMotos.datosAsegurado) || (estadoMotos && estadoMotos.carrito && estadoMotos.carrito.datosAsegurado) || {};
    var dc = (estadoMotos && estadoMotos.datosConductor) || (estadoMotos && estadoMotos.carrito && estadoMotos.carrito.datosConductor) || {};

    var numValor = parseFloat(datosVehiculo.valorAsegurado) || 0;
    var valorAseguradoStr = '$' + numValor.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var numExtras = parseFloat(datosVehiculo.valorExtras) || 0;
    var valorExtrasStr = '$' + numExtras.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    var handleRegresar = function() {
        if (history) {
            var currentId = idCarrito || (estadoMotos && estadoMotos.idCarrito);
            history.push('/motos/emision' + (currentId ? ('?idCarrito=' + currentId) : ''));
        }
    };

    var handleConfirmarEmision = function() {
        if (esBloqueanteEmision && txtBloqueoEmision) {
            return;
        }
        if (history) {
            var currentId = idCarrito || (estadoMotos && estadoMotos.idCarrito);
            history.push('/motos/facturacion' + (currentId ? ('?idCarrito=' + currentId) : ''));
        }
    };

    return (
        <LoadingScreen
            loading={isGlobalLoading}
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text="Cargando resumen de cotización..."
        >
            <div className="cr-content container-fluid">
                <div className="container-body-spaces">
                    <Page
                        title="Resumen de Cotización de Motos"
                        breadcrumbs={[
                            { name: "Cotización de Motos", active: false },
                            { name: "Resumen", active: true }
                        ]}
                    >
                        {/* Stepper Superior (3 Pasos) */}
                        <Row className="mb-3">
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <Steps 
                                    tipo={'parametrico'} 
                                    listaOpciones={listaOpciones} 
                                    paso={'resumen'} 
                                />
                            </Col>
                        </Row>

                        {estadoMotos && estadoMotos.error && (
                            <Row>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    <Alert color="danger">
                                        {estadoMotos.error}
                                    </Alert>
                                </Col>
                            </Row>
                        )}

                        {!isGlobalLoading && (
                            <Row style={{ alignItems: 'flex-start' }}>
                                {/* Columna Izquierda: Tarjetas de Resumen Visual */}
                                <Col lg={8} md={12} sm={12} xs={12}>
                                    
                                    {/* 1. Datos del Vehículo */}
                                    <Card className="shadow-sm mb-4" style={styles.card}>
                                        <CardBody style={{ padding: '20px 24px' }}>
                                            <h4 style={Object.assign({}, styles.titulo, { marginBottom: '16px' })}>
                                                Datos del Vehículo
                                            </h4>

                                            <div style={styles.boxGris}>
                                                <Row>
                                                    <Col md={4} sm={6} xs={12} className="mb-3">
                                                        <span style={styles.label}>Marca:</span>
                                                        <span style={styles.valor}>{datosVehiculo.marcaNombre || datosVehiculo.marca || 'N/A'}</span>
                                                    </Col>
                                                    <Col md={4} sm={6} xs={12} className="mb-3">
                                                        <span style={styles.label}>Modelo:</span>
                                                        <span style={styles.valor}>{datosVehiculo.modeloNombre || datosVehiculo.modelo || 'N/A'}</span>
                                                    </Col>
                                                    <Col md={4} sm={6} xs={12} className="mb-3">
                                                        <span style={styles.label}>Año:</span>
                                                        <span style={styles.valor}>{datosVehiculo.anio || 'N/A'}</span>
                                                    </Col>
                                                    <Col md={4} sm={6} xs={12} className="mb-3">
                                                        <span style={styles.label}>Placa:</span>
                                                        <span style={styles.valor}>{datosVehiculo.placa || 'SIN PLACA'}</span>
                                                    </Col>
                                                    <Col md={4} sm={6} xs={12} className="mb-3">
                                                        <span style={styles.label}>Color:</span>
                                                        <span style={styles.valor}>{datosVehiculo.colorNombre || datosVehiculo.color || 'N/A'}</span>
                                                    </Col>
                                                    <Col md={4} sm={6} xs={12} className="mb-3">
                                                        <span style={styles.label}>Valor Casco:</span>
                                                        <span style={Object.assign({}, styles.valor, { fontWeight: 'bold' })}>{valorAseguradoStr}</span>
                                                    </Col>
                                                    <Col md={4} sm={6} xs={12} className="mb-3">
                                                        <span style={styles.label}>Amparo Patrimonial:</span>
                                                        <span style={styles.valor}>{datosVehiculo.amparoPatrimonial ? 'SÍ (0.30%)' : 'NO'}</span>
                                                    </Col>
                                                    {datosVehiculo.polizaAutoVigente && (
                                                        <Col md={4} sm={6} xs={12} className="mb-3">
                                                            <span style={styles.label}>Póliza de Auto Previa:</span>
                                                            <span style={styles.valor}>{datosVehiculo.polizaAutoVigente}</span>
                                                        </Col>
                                                    )}
                                                </Row>

                                                {/* Resumen de Accesorios Extras */}
                                                {datosVehiculo.poseeExtras === 'si' && (
                                                    <div className="pt-3 mt-2 border-top" style={{ borderColor: '#d9d9d9' }}>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                                            <span style={styles.label}>Accesorios Extras Asegurados:</span>
                                                            <span style={{ fontWeight: 'bold', color: '#000000', fontSize: '14px' }}>{valorExtrasStr}</span>
                                                        </div>
                                                        <ul className="mb-0 pl-3">
                                                            {Array.isArray(datosVehiculo.accesorios) && datosVehiculo.accesorios.map(function(acc, idx) {
                                                                var accLabel = (typeof acc === 'object' && acc !== null) ? (acc.label || acc.accNombre || acc.nombre) : acc;
                                                                return <li key={'acc-' + idx} style={{ fontSize: '14px', color: '#515253' }}>{accLabel}</li>;
                                                            })}
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                        </CardBody>
                                    </Card>

                                    {/* 2. Datos del Cliente */}
                                    <Card className="shadow-sm mb-4" style={styles.card}>
                                        <CardBody style={{ padding: '20px 24px' }}>
                                            <h4 style={Object.assign({}, styles.titulo, { marginBottom: '16px' })}>
                                                Datos del Cliente
                                            </h4>

                                            <div style={styles.boxGris}>
                                                <h6 style={{ fontWeight: 'bold', color: '#000000', marginBottom: '12px', fontSize: '15px', fontFamily: 'Futura, sans-serif' }}>
                                                    Asegurado Principal
                                                </h6>
                                                <Row>
                                                    <Col md={4} sm={6} xs={12} className="mb-3">
                                                        <span style={styles.label}>Nombres Completos:</span>
                                                        <span style={styles.valor}>{da.nombres || 'N/A'}</span>
                                                    </Col>
                                                    <Col md={4} sm={6} xs={12} className="mb-3">
                                                        <span style={styles.label}>Identificación:</span>
                                                        <span style={styles.valor}>{((da.tipoDocumento && da.tipoDocumento.label) || (da.tipoDocumento && da.tipoDocumento.value === '2' ? 'RUC' : (da.tipoDocumento && da.tipoDocumento.value === '3' ? 'Pasaporte' : 'Cédula de Identidad')) || 'Cédula de Identidad')}: {da.identificacion || 'N/A'}</span>
                                                    </Col>
                                                    <Col md={4} sm={6} xs={12} className="mb-3">
                                                        <span style={styles.label}>Fecha Nacimiento:</span>
                                                        <span style={styles.valor}>{da.fechaNacimiento || 'N/A'}</span>
                                                    </Col>
                                                    <Col md={4} sm={6} xs={12} className="mb-3">
                                                        <span style={styles.label}>Celular:</span>
                                                        <span style={styles.valor}>{da.celular || 'N/A'}</span>
                                                    </Col>
                                                    <Col md={4} sm={6} xs={12} className="mb-3">
                                                        <span style={styles.label}>Correo Electrónico:</span>
                                                        <span style={styles.valor}>{da.correo || 'N/A'}</span>
                                                    </Col>
                                                    <Col md={4} sm={6} xs={12} className="mb-3">
                                                        <span style={styles.label}>Dirección:</span>
                                                        <span style={styles.valor}>{da.direccion || 'N/A'}</span>
                                                    </Col>
                                                </Row>

                                                {/* Datos del Conductor */}
                                                <div className="pt-3 mt-3 border-top" style={{ borderColor: '#d9d9d9' }}>
                                                    <h6 style={{ fontWeight: 'bold', color: '#000000', marginBottom: '8px', fontSize: '15px', fontFamily: 'Futura, sans-serif' }}>
                                                        Conductor
                                                    </h6>
                                                    {dc.mismosDatosAsegurado !== false ? (
                                                        <p style={{ fontSize: '14px', color: '#515253', margin: 0 }}>
                                                            El conductor habitual es el mismo Asegurado Principal.
                                                        </p>
                                                    ) : (
                                                        <Row>
                                                            <Col md={4} sm={6} xs={12} className="mb-2">
                                                                <span style={styles.label}>Nombres:</span>
                                                                <span style={styles.valor}>{dc.nombres || 'N/A'}</span>
                                                            </Col>
                                                            <Col md={4} sm={6} xs={12} className="mb-2">
                                                                <span style={styles.label}>Identificación:</span>
                                                                <span style={styles.valor}>{((dc.tipoDocumento && dc.tipoDocumento.label) ? dc.tipoDocumento.label + ': ' : '')}{dc.identificacion || 'N/A'}</span>
                                                            </Col>
                                                            <Col md={4} sm={6} xs={12} className="mb-2">
                                                                <span style={styles.label}>Fecha Nacimiento:</span>
                                                                <span style={styles.valor}>{dc.fechaNacimiento || 'N/A'}</span>
                                                            </Col>
                                                            <Col md={4} sm={6} xs={12} className="mb-2">
                                                                <span style={styles.label}>Género:</span>
                                                                <span style={styles.valor}>{((dc.genero && dc.genero.label) || dc.genero) || 'N/A'}</span>
                                                            </Col>
                                                            <Col md={4} sm={6} xs={12} className="mb-2">
                                                                <span style={styles.label}>Parentesco con el asegurado:</span>
                                                                <span style={styles.valor}>{((dc.parentesco && dc.parentesco.label) || dc.parentesco) || 'N/A'}</span>
                                                            </Col>
                                                            <Col md={4} sm={6} xs={12} className="mb-2">
                                                                <span style={styles.label}>Estado Civil:</span>
                                                                <span style={styles.valor}>{((dc.estadoCivil && dc.estadoCivil.label) || dc.estadoCivil) || 'N/A'}</span>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>

                                    {/* 3. Tarjeta de Coberturas y Asistencias */}
                                    <CoberturasMoto 
                                        coberturas={coberturas} 
                                        planNombre={planNombre}
                                    />

                                    {/* Botón Regresar / Modificar Datos al final */}
                                    <div className="pt-2 pb-4">
                                        <Button 
                                            color="secondary" 
                                            onClick={handleRegresar}
                                            style={{ display: 'inline-flex', alignItems: 'center' }}
                                        >
                                            <i className="fa fa-arrow-left mr-2"></i> Modificar Información
                                        </Button>
                                    </div>
                                </Col>

                                {/* Columna Derecha: Tarjeta de Valores Sticky */}
                                <Col lg={4} md={12} sm={12} xs={12} style={{ position: 'sticky', top: '20px', zIndex: 10 }}>
                                    <ValoresCotizacionMoto 
                                        valorTotal={valorTot}
                                        cotizacion={estadoMotos && estadoMotos.cotizacion}
                                        huboCambio={false}
                                        onIniciarEmision={handleConfirmarEmision}
                                        idCotizacion={(estadoMotos && estadoMotos.idCotizacion) || ''}
                                        textoBotonEmision="INICIAR EMISIÓN"
                                        esBloqueanteEmision={esBloqueanteEmision}
                                        txtBloqueoEmision={txtBloqueoEmision}
                                    />
                                </Col>
                            </Row>
                        )}
                    </Page>
                </div>
            </div>
        </LoadingScreen>
    );
};

const mapStateToProps = (state) => ({
    estadoMotos: state.dataMotos || state.motos || {}
});

const mapDispatchToProps = {
    obtenerCotizacionMoto,
    limpiarDatosCotizacion
};

export default connect(mapStateToProps, mapDispatchToProps)(ResumenMoto);
